import React from 'react';
import Logo from '../Logo';

const CTA = ({ onNavigateLogin }) => {
  return (
    <div className="bg-neutral-800 px-8 relative overflow-visible">
      <div className="max-w-5xl mx-auto relative z-50">
        <div className="bg-gradient-to-br from-[#055EFD] to-[#0449d4] rounded-lg shadow-2xl p-8 translate-y-16 relative overflow-hidden">
          <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-20 w-[300px] h-[300px] z-0">
            <Logo width="100%" height="100%" logoFill="indigo" mobile={true} />
          </div>
          <div className="flex flex-col md:flex-row items-center gap-6 relative z-10">
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="fa fa-terminal text-white text-xl"></i>
            </div>
            <div className="flex-1 text-center md:text-left pl-4">
              <h3 className="!text-white !text-2xl lg:text-3xl font-bold font-['Montserrat'] mb-2">
                Deploy an AI employee in minutes, not months
              </h3>
              <p className="!text-white/80 text-base font-medium font-['Inter']">
                Join developers building autonomous AI agents that coordinate with real teams.
              </p>
            </div>
            <div className="flex flex-col items-center md:items-end gap-2">
              <button
                onClick={() => onNavigateLogin(true)}
                className="px-6 py-3 bg-white rounded hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="text-[#055EFD] text-sm font-bold font-['Inter']">Get Your API Key</span>
              </button>
              <p className="!text-white/70 text-xs font-medium font-['Inter']">Free to start building</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTA;
